<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="shaparakRequestsFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#shaparakRequestsFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="12" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('shaparakRequests.status') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3" id="status" class="form-control"
                                                    name="status" v-model="query.status"
                                            >
                                                <option
                                                        v-for="(status, index) in shRequestStatuses"
                                                        v-bind:key="index"
                                                        v-bind:value="status.value"
                                                        :selected="query.status === status.value"
                                                >
                                                    {{ status.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="request_type">
                                                {{ $t('shaparakRequests.request_type') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3" id="request_type" class="form-control"
                                                    name="request_type" v-model="query.request_type"
                                            >
                                                <option
                                                        v-for="(request_type, index) in shRequestTypes"
                                                        v-bind:key="index"
                                                        v-bind:value="request_type.value"
                                                        :selected="query.request_type === request_type.value"
                                                >
                                                    {{ request_type.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="">
                                                {{ $t('shaparakRequests.tracking_number') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="tracking_number"
                                                    name="tracking_number" id="tracking_number"
                                                    v-model="query.tracking_number"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="">
                                                {{ $t('shaparakRequests.gateway_title') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="farsi_name"
                                                    name="farsi_name" id="farsi_name"
                                                    v-model="query.farsi_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="gateway_type">
                                                {{ $t('label.gateway_type') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3" id="gateway_type" class="form-control"
                                                    name="gateway_type" v-model="query.gateway_type"
                                            >
                                                <option
                                                        v-for="(gateway_type, index) in gatewayTypes"
                                                        v-bind:key="index"
                                                        v-bind:value="gateway_type.value"
                                                        :selected="query.gateway_type === gateway_type.value"
                                                >
                                                    {{ gateway_type.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="">
                                                {{ $t('shaparakRequests.user_name') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="user_name"
                                                    name="user_name" id="user_name"
                                                    v-model="query.user_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3" lg="3">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>

                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

    import { i18n } from '@/plugins/i18n'
    import { shRequestStatusStr } from '@/constants/shaparakRequestStatus'
    import { shRequestStatus } from '@/constants/shaparakRequestStatus'
    import { shRequestType } from '@/constants/shaparakRequestType'
    import { shRequestTypeStr } from '@/constants/shaparakRequestType'

    export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            }
        },
        data() {
            return {
                gatewayTypes: [
                    {
                        value: null,
                        name: null
                    },
                    {
                        value: 2,
                        name: i18n.t('gateway.gateway_types.business')
                    },
                    {
                        value: 4,
                        name: i18n.t('gateway.gateway_types.business_psp_settlement')
                    }
                ],
                shRequestStatuses: [
                    {
                        value: null,
                        name: null
                    },
                    {
                        value: shRequestStatus.CONFIRMED,
                        name: shRequestStatusStr.CONFIRMED
                    },
                    {
                        value: shRequestStatus.PENDING,
                        name: shRequestStatusStr.PENDING
                    },
                    {
                        value: shRequestStatus.FINAL_REJECT,
                        name: shRequestStatusStr.FINAL_REJECT
                    },
                    {
                        value: shRequestStatus.DELAY,
                        name: shRequestStatusStr.DELAY
                    }
                ],
                shRequestTypes: [
                    {
                        value: null,
                        name: null
                    },
                    {
                        value: shRequestType.NEW_TERMINAL,
                        name: shRequestTypeStr.NEW_TERMINAL
                    },
                    {
                        value: shRequestType.CHANGE_TERMINAL_SHEBA,
                        name: shRequestTypeStr.CHANGE_TERMINAL_SHEBA
                    },
                    {
                        value: shRequestType.CHANGE_SHOP_LOCATION,
                        name: shRequestTypeStr.CHANGE_SHOP_LOCATION
                    },
                    {
                        value: shRequestType.DISABLE_TERMINAL,
                        name: shRequestTypeStr.DISABLE_TERMINAL
                    },
                    {
                        value: shRequestType.ENABLE_TERMINAL,
                        name: shRequestTypeStr.ENABLE_TERMINAL
                    },
                    {
                        value: shRequestType.CHANGE_CATEGORY_CODE,
                        name: shRequestTypeStr.CHANGE_CATEGORY_CODE
                    }
                ],
                query: {},
            }
        },
        methods: {
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
        },
        mounted() {
        }

    }
</script>

<style>

</style>